<template>
  <v-row no-gutters>
    <v-col>
      <v-row v-if="!itsPartialPayment" no-gutters>
        <h4
          v-if="finalDetails?.orderData?.hash_pedido"
          class="checkout-h4 confirmation-subtitle mb-0 pb-2 accent--text"
        >
          {{ $t("finished.digitalTicket") }}
        </h4>
        <h4
          v-if="!finalDetails?.orderData?.hash_pedido"
          class="checkout-h4 confirmation-subtitle"
        >
          {{ $t("finished.ticketsSent") }}{{ buyer.customer_email }}
        </h4>
        <span
          v-if="
            finalDetails &&
            finalDetails.orderData &&
            !finalDetails.orderData.hash_pedido &&
            !itsPartialPayment
          "
          class="checkout-h4 grey--text"
        >
          {{ $t("finished.notReceived") }}
        </span>
      </v-row>
      <v-row class="mt-2" no-gutters>
        <v-btn
          v-if="finalDetails?.orderData?.hash_pedido && !itsPartialPayment"
          block
          rounded
          class="normal-text"
          color="primary"
          dark
          depressed
          target="_blank"
          :href="finalDetails.orderData.ticketsUrl"
          >{{
            finalDetails.orderData && finalDetails.orderData.ticketsCaption
              ? finalDetails.orderData.ticketsCaption
              : $t("finished.seeTickets")
          }}</v-btn
        >
        <v-btn
          v-else-if="!itsPartialPayment"
          block
          rounded
          class="mt-2"
          color="primary"
          dark
          depressed
          target="_blank"
          :href="urlSite"
          >{{ $t("finished.accessAccount") }}</v-btn
        >
        <div style="width: 100% !important" v-if="itsPartialPayment">
          <div>
            <span class="checkout-h4 accent--text"
              >{{ $t("finished.orderBalance") }}
              {{ itsPartialPayment | currency
              }}{{ $t("finished.toSwitchOff") }}</span
            >
          </div>
          <div class="pt-2 checkout-h4 accent--text">
            <span>{{ $t("finished.newPayment") }}</span>
          </div>
          <v-row no-gutters class="mt-4" justify="center">
            <v-btn
              @click="goToPayment"
              rounded
              depressed
              width="40%"
              color="primary"
              class="mr-2"
              style="text-transform: none"
              >{{ $t("finished.makeNewPayment") }}</v-btn
            >
            <v-btn
              @click="clickCopy"
              rounded
              depressed
              outlined
              width="40%"
              color="primary"
              style="text-transform: none"
              >{{ $t("finished.copyLink") }}</v-btn
            >
          </v-row>
        </div>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: ["itsPartialPayment"],
  computed: {
    ...mapGetters([
      "postOrder",
      "userProps",
      "finalDetails",
      "buyer",
      "storeDetails",
      "eventId",
    ]),
    urlSite() {
      return "https://site.blueticket.com.br/ingressos";
    },
  },
  methods: {
    goToPayment() {
      window.open(
        `${this.storeDetails.siteUrl}/checkout/${this.eventId}?order_hash=${this.finalDetails.orderData.hash_pedido}`,
        "_self"
      );
    },
    clickCopy() {
      navigator.clipboard.writeText(
        `${this.storeDetails.siteUrl}/checkout/${this.eventId}?order_hash=${this.finalDetails.orderData.hash_pedido}`
      );
    },
  },
};
</script>
